<template>
  <div class="st-travel-sausage">
    <travel-sausage-badge :color="color">
      <template v-slot:icon><component :is="icon" /> </template>
    </travel-sausage-badge>

    <span :aria-label="ariaLabel">
      {{ text }}
    </span>
  </div>
</template>

<script>
import TravelSausageBadge from "./TravelSausageBadge.vue";
import CallTrafficIcon from "../../icons/st/call-traffic.vue";
import WalkIcon from "../../icons/st/walk.vue";
import BusIcon from "../../icons/st/bus.vue";
import TrainIcon from "../../icons/st/train.vue";
import TramIcon from "../../icons/st/tram.vue";
import FerryIcon from "../../icons/st/ferry.vue";

export default {
  name: "st-travel-sausage",
  components: {
    TravelSausageBadge,
    BusIcon,
    TrainIcon,
    CallTrafficIcon,
    WalkIcon,
  },
  props: {
    trafficType: String,
    text: String,
    ariaLabel: String,
    tabindex: {
      type: String,
      default: "0",
    },
    color: String,
  },
  computed: {
    icon() {
      const badgeIcon = {
        bus: BusIcon,
        train: TrainIcon,
        calltraffic: CallTrafficIcon,
        metro: TramIcon,
        walk: WalkIcon,
        ferry: FerryIcon,
      };
      return badgeIcon[this.trafficType];
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../scss/main.scss";

@mixin three20 {
  @media (max-width: 320px) {
    @content;
  }
}

.st-travel-sausage {
  display: flex;
  align-items: center;
  flex-direction: row;
  background-color: $bg-grey;
  border-radius: rem-calc(4);
  font-family: $source-sans-pro;
  font-weight: $regular;
  font-size: rem-calc(16);
  line-height: rem-calc(24);
  color: $dark-grey;
  flex-grow: 1;
  padding-right: rem-calc(4);
  @include large {
    font-size: rem-calc(18);
  }

  @include three20 {
    font-size: rem-calc(13);
  }

  & > *:not(:last-child) {
    margin-right: rem-calc(8);
  }
}
</style>
